/**
 * @module PC版ページタイトル部共通コンポーネント
 */
export default {
  name: 'PcPageTitle',
  props: {
    title: {
      type: String,
      default: '',
      require: true,
    },
    hintText: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  /** @type {Methods} */
  methods: {
    /**
     * ヘルプダイアログ表示処理
     */
    async callHelpDialog() {
      await this.$helpDialog(
        '$vuetify.messageDialog.ヘルプ',
        this.hintText,
        '$vuetify.messageDialog.OK'
      );
    },
  },
};
